// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
//= require deprecated_object_hierarchy/object_extensions
//= require_tree .
// MAGIC_DESPROCKET_START
require('javascripts/deprecated_object_hierarchy/object_extensions.js')
require('javascripts/deprecated_object_hierarchy/base.js')
// MAGIC_DESPROCKET_END
